var map = {
	"./counter-cards/i18n/en.json": "1514",
	"./counter-cards/i18n/fr.json": "6117f",
	"./criticality-tickets/i18n/en.json": "3210",
	"./criticality-tickets/i18n/fr.json": "f5d0",
	"./open-tickets-software/i18n/en.json": "9820",
	"./open-tickets-software/i18n/fr.json": "9a9b",
	"./open-tickets/i18n/en.json": "dc0e",
	"./open-tickets/i18n/fr.json": "045c",
	"./software/i18n/en.json": "e64e",
	"./software/i18n/fr.json": "d5cb",
	"./tickets-priority-anomalies/i18n/en.json": "71b9",
	"./tickets-priority-anomalies/i18n/fr.json": "58ce",
	"./tickets-volume-type/i18n/en.json": "c597",
	"./tickets-volume-type/i18n/fr.json": "4b9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd65";